import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DI from "../utility/DI";
import { useNavigate } from "react-router-dom";
import Footer from "../utility/Footer";
import { PasswordInput } from "../utility/PasswordInput";
import { CircularProgress } from "@mui/material";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

const Signup = (props) => {
  const {
    di: { POST, urls, error, success },
  } = props;
  const [loginSuccess, setLoginSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const fetchFriends = () => {
    POST(urls.get.get_friends).then((res) => {
      if (res?.success) {
        setLoginSuccess(true);
      }
    });
  };
  React.useEffect(() => {
    fetchFriends();
  }, []);
  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const form = event.currentTarget;
    const data = new FormData(event.currentTarget);
    const formDataObject = {};

    for (const [key, value] of data.entries()) {
      formDataObject[key.toLowerCase()] = value;
    }

    POST(urls.post.signup, formDataObject)
      .then((res) => {
        if (res.success) {
          success(res.message);
          form.reset();
          // Redirect to email verification page
          navigate(`/verify_email?email=${encodeURIComponent(res.email || formDataObject.email)}`);
        } else error(res.message);
        setLoading(false);
      })
      .catch((er) => {
        console.log("error ocuured.", er);
        setLoading(false);
      });
  };
  React.useEffect(() => {
    fetchFriends();
  }, []);

  React.useEffect(() => {
    if (loginSuccess) navigate("/panel");
  }, [loginSuccess]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px" }}>
          <img
            style={{ width: "100%" }}
            src={"/transparent_logo.png"}
            alt={"spent_app"}
            loading="lazy"
          />
        </div>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <Box
          component="form"
          noValidate
          onSubmit={handleSubmit}
          sx={{ mt: 3, px: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="given-name"
                name="firstName"
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="family-name"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                helperText="Note: provide a valid email to restore your account anytime."
              />
            </Grid>
            <Grid item xs={12}>
              <PasswordInput
                required
                fullWidth
                name="password"
                label="Password"
                id="password"
                autoComplete="new-password"
              />
            </Grid>
            {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox value="allowExtraEmails" color="primary" />
                  }
                  label="I want to receive inspiration, marketing promotions and updates via email."
                />
              </Grid> */}
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              " Sign Up"
            )}
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Link
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer" }}
                variant="body2"
              >
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <div style={{ marginTop: "20px" }}>
        <Footer />
      </div>
    </Container>
  );
};
export default DI(Signup);
